import { resolveBgColorVariant, resolveColorVariant } from './resolveColorVariant';
const iconStartStyleDecorator = (variant, theme) => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.tokens.ComponentFlagIconSize,
    color: resolveColorVariant(variant, theme) ?? theme.tokens.ComponentFlagIconDefaultColor,
    strokeWidth: '1.13'
  };
};
const swallowTailStyleDecorator = (variant, theme) => {
  return {
    borderTopStyle: 'solid',
    borderTopWidth: '8px',
    borderTopColor: resolveBgColorVariant(variant, theme) ?? theme.tokens.ComponentFlagVariantLightBg,
    borderRightStyle: 'solid',
    borderRightWidth: '8px',
    borderRightColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: '8px',
    borderBottomColor: resolveBgColorVariant(variant, theme) ?? theme.tokens.ComponentFlagVariantLightBg
  };
};
export { iconStartStyleDecorator, swallowTailStyleDecorator };